'use strict';

var React = require('react');

const FeaturesContext = /*#__PURE__*/React.createContext(undefined);

exports.FeaturesContext = FeaturesContext;
